import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { useLocation } from 'react-router';
import TopbarUserMenu from '../TopbarUserMenu/TopbarUserMenu';
import Logo from '../Logo/Logo';
import { HeaderMenu } from '../HeaderMenu/HeaderMenu';
import HeaderMenuDrawer from '../HeaderMenu/HeaderMenuDrawer';
import { windowMaxWidth } from '../ui/Layout/breakpoints';
import { selectConfig } from '../../redux/config/selectors';
import { selectUiRights } from '../../redux/authentication/selectors';
import {
  selectGeneralMessagesItemCount,
  selectWorklistClaimsItemCount,
  selectWorklistRisksItemCount
} from '../../redux/worklists/selectors';

const HeaderWrapper = styled.div`
  background-color: var(--greyscale-white);
  box-shadow: var(--box-shadow-header-menu);
  display: flex;
  height: 60px;
  padding: 0 30px;
  width: 100vw;
  z-index: 999;

  @media (${windowMaxWidth.mobile}) {
    padding: 0 20px;
    position: fixed;
    top: 0;
  }
`;

const HederInnerWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  width: calc(100vw - 40px);
`;

const Header = ({ config, uiRights, generalMessagesItemCount, worklistClaimsItemCount, worklistRisksItemCount }) => {
  const location = useLocation();

  const parsedItemCounts = {
    generalMessages: generalMessagesItemCount,
    claims: worklistClaimsItemCount,
    risks: worklistRisksItemCount
  };

  return (
    <HeaderWrapper>
      <HederInnerWrapper>
        <HeaderMenuDrawer uiRights={uiRights} path={location.pathname} />
        <Logo
          agencyLogo={config?.tenant_logo?.url_small || config?.tenant_logo?.url}
          agencyName={config?.tenant_name}
        />
        <HeaderMenu uiRights={uiRights} path={location.pathname} parsedItemCounts={parsedItemCounts} />
        <TopbarUserMenu />
      </HederInnerWrapper>
    </HeaderWrapper>
  );
};

const mapStateToProps = (state) => ({
  config: selectConfig(state),
  uiRights: selectUiRights(state),
  generalMessagesItemCount: selectGeneralMessagesItemCount(state),
  worklistClaimsItemCount: selectWorklistClaimsItemCount(state),
  worklistRisksItemCount: selectWorklistRisksItemCount(state)
});

export default connect(mapStateToProps)(Header);
